import { IIconProps } from "."

export const BackIcon = ({ size = 20 }: IIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 12 20" fill="none">
			<path
				d="M0 10C0 10.3931 0.145996 10.73 0.460449 11.022L9.19775 19.5796C9.44482 19.8267 9.75928 19.9614 10.1299 19.9614C10.8711 19.9614 11.4663 19.3774 11.4663 18.625C11.4663 18.2544 11.3091 17.9287 11.062 17.6704L3.18945 10L11.062 2.32959C11.3091 2.07129 11.4663 1.73438 11.4663 1.375C11.4663 0.622559 10.8711 0.0385742 10.1299 0.0385742C9.75928 0.0385742 9.44482 0.17334 9.19775 0.42041L0.460449 8.9668C0.145996 9.27002 0 9.60693 0 10Z"
				fill="white"
			/>
		</svg>
	)
}
